module.exports = __webpack_public_path__ + "img/be.6cac0379.svg";